import { render, staticRenderFns } from "./DeleteCardModal.vue?vue&type=template&id=1fbccd13&"
import script from "./DeleteCardModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./DeleteCardModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports